module.exports = __webpack_public_path__ + "static/media/Warning.9f8c8db5.svg";